<template>
    <teleport to="body">
        <div v-for="modal in modals" :key="modal.id" class="modal-container" data-modal-container>
            <component :is="modal.component" v-bind="modal.props" @close="closeModal(modal.id)" />
        </div>
    </teleport>
</template>

<script setup>
import { useModalStore } from "@/stores/modalStore"

const { modals, closeModal } = useModalStore()
</script>
